import React from "react";
import { Users } from "react-feather";

import SectionLayout from "../../layouts/SectionLayout";
import { RouteInfoType } from "../../types/types";
import PartnerDetailsPage from "./pages/PartnerDetailsPage";
import PartnersPage from "./pages/PartnersPage";

const partnersRoutes = [
    {
        id: "partners",
        path: "/partners/",
        name: "Партнёры",
        icon: <Users />,
        component: SectionLayout,
        nonCollapsable: true,
        superUserOnly: true,
        routes: [
            {
                path: "/partners/general",
                exact: true,
                name: "Партнёры",
                component: PartnersPage,
            },
            {
                hide: true,
                path: "/partners/general/:partnerId",
                name: "Партнёр",
                component: PartnerDetailsPage,
            },
        ],
    },
];

export default partnersRoutes as RouteInfoType[];
